import { BOOKING_TYPE_VALUES } from '../booking/index.js';
export const USAGE_DENOMINATORS = ['bookable', 'public'];
export const USAGE_DIMENSIONS = ['bay', 'weekday', 'date', 'hour', 'type', 'paymentType', 'source'];
export const USAGE_GROUPING_ALIASES = ['auto_hour'];
export const USAGE_AUTO_HOUR_BY_DATE_MAX_DAYS = 7;
export const USAGE_REPORTED_BOOKING_TYPES = BOOKING_TYPE_VALUES.filter((type) => type !== 'block');
export const USAGE_INCLUDES = ['customers', 'utilization'];
export const USAGE_MAX_ROWS = 5000;
export const USAGE_MAX_REQUEST_ROWS = 20000;
export const USAGE_MAX_GROUPINGS = 8;
export const USAGE_MAX_DIMENSIONS = 3;
export const USAGE_MAX_BAY_IDS = 100;
//# sourceMappingURL=usage.js.map